import React, { useEffect, useState } from "react";
import "./Home.css";

const Home = () => {
  const villageName = "";

  const heroImages = [
    "/images/slider1.jpeg",
    "/images/slider2.jpeg",
    "/images/slider3.jpeg",
    "/images/slider4.jpeg",
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroImages.length]);

  // ===== Leader Data =====
  const sarpanch = {
    name: "श्री.राजेंद्र पांडुरंग पाटील",
    phone: "9960423057",
    photo: "/images/sarpanch.jpeg",
    role: "प्रशासक",
  };

  const sachiv = {
    name: "सौ. तनुजा राजेंद्र सावे",
    phone:"9764001546",
    photo: "/images/sachiv.jpeg",
    role: "ग्रामपंचायत अधिकारी (ग्रामसेवक)",
    
  };

  const members = [];

  // ===== Maharashtra Leaders =====
  const maharashtraLeaders = [
    { name: "श्री. देवेंद्र फडणवीस (मुख्यमंत्री)", photo: "/images/cm.jpg" },
    { name: "श्री एकनाथ शिंदे (उपमुख्यमंत्री)", photo: "/images/eknath.jpg" },
    { name: "सौ सुनैत्रा अजित पवार (उपमुख्यमंत्री)", photo: "/images/sunetra.jpeg" },
    { name: "श्री योगेश कदम (मा.राज्यमंत्री, ग्रामविकास व पंचायत राज विभाग)", photo: "/images/yogesh.jpeg" },
    { name: "श्री जयकुमार गोरे (मा.मंत्री, ग्रामविकास व पंचायत राज विभाग)", photo: "/images/gore.jpg" },
    { name: "श्री गणेश नाईक (वनमंत्री)", photo: "/images/ganesh.png" },
    { name: "श्री हेमंत सवरा (खासदार, पालघर)", photo: "/images/hemant.jpg" },
    { name: "श्री विलास तरे (आमदार, बोईसर)", photo: "/images/vilas.jpg" },
    { name: "श्री मनोज रानडे (मुख्य कार्यकारी अधिकारी, जि.प. पालघर)", photo: "/images/manoj.jpg" },
    { name: "श्री रविंद्र शिंदे (मा. अति. मुख्य कार्यकारी अधिकारी)", photo: "/images/ravindra.jpg" },
    { name: "श्री अशोक पाटील (उपमुख्य कार्यकारी अधिकारी)", photo: "/images/ashok.jpg" },
    { name: "सौ पल्लवी सस्ते (गटविकास अधिकारी)", photo: "/images/bdo.jpeg" },
  ];

  const SafeImage = ({ src, alt }) => {
    const fallback = "https://via.placeholder.com/300x300/D3D3D3/666666?text=फोटो+नाही";
    const [img, setImg] = useState(src);

    return (
      <img
        src={img}
        alt={alt}
        onError={() => setImg(fallback)}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    );
  };

  return (
    <div className="home-container">
      {/* Marquee */}
      <div className="marquee-wrapper">
        <div className="marquee">
          ग्रामपंचायत धाकटी-डहाणू | पंचायत समिती डहाणू, जि. पालघर | संपर्क:- 9960423057
        </div>
      </div>

      {/* Hero Section */}
      <section className="hero">
        {heroImages.map((img, i) => (
          <div
            key={i}
            className={`hero-slide ${currentSlide === i ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>ग्रामपंचायत "धाकटी-डहाणू" आपले स्वागत आहे {villageName}</h1>
            <p>आमच्या गावाचा सर्वांगीण विकास हेच आमचे ध्येय!</p>
            <a href="/aboutus">अधिक माहिती</a>
          </div>
        </div>
      </section>

      {/* Maharashtra Leaders Section */}
      <section className="section">
        <h2 className="title">महाराष्ट्र शासन प्रतिनिधी</h2>
        <div className="leaders-grid">
          {maharashtraLeaders.map((leader, index) => (
            <div className="leader-card" key={index}>
              <div className="leader-img">
                <SafeImage src={leader.photo} alt={leader.name} />
              </div>
              <p>{leader.name}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ===== Main Leaders Section with Right Side Content ===== */}
      <section className="section">
        <h2 className="title">ग्रामपंचायत प्रतिनिधी</h2>
        
        <div className="layout" style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
          
          {/* Left Side - Photos */}
          <div className="leaders" style={{ flex: "1", minWidth: "300px" }}>
            {/* प्रशासक (सरपंच) */}
            <div className="leader-card sarpanch-card">
              <div className="leader-img">
                <SafeImage src={sarpanch.photo} alt="प्रशासक" />
              </div>
              <h3>प्रशासक</h3>
              <b>{sarpanch.name}</b>
              <p style={{ marginTop: "8px", fontSize: "14px" }}>संपर्क: {sarpanch.phone}</p>
            </div>

            {/* ग्रामपंचायत अधिकारी (ग्रामसेवक) */}
            <div className="leader-card sachiv-card">
              <div className="leader-img">
                <SafeImage src={sachiv.photo} alt="ग्रामसेवक" />
              </div>
              <h3>ग्रामपंचायत अधिकारी (ग्रामसेवक)</h3>
              <b>{sachiv.name}</b>
            </div>
          </div>

          {/* Right Side - Rules & Responsibilities (Big Area) */}
          <div className="responsibilities" style={{ flex: "2", minWidth: "400px" }}>
            <div className="responsibility-box">
              <h3>प्रशासक (सरपंच) यांचे अधिकार व जबाबदाऱ्या</h3>
              <ul>
                <li>ग्रामपंचायतेचे प्रमुख प्रशासक म्हणून काम करणे</li>
                <li>ग्रामसभेचे अध्यक्षस्थान भूषवणे</li>
                <li>ग्रामपंचायतेच्या विकासकामांचा देखरेख व अंमलबजावणी</li>
                <li>सरकारच्या विविध योजना गावात राबवणे</li>
                <li>ग्रामपंचायतेच्या बैठका घेणे व निर्णय घेणे</li>
                <li>गावातील विवाद सोडवणे व शांतता राखणे</li>
              </ul>
            </div>

            <div className="responsibility-box" style={{ marginTop: "25px" }}>
              <h3>ग्रामपंचायत अधिकारी (ग्रामसेवक) यांचे कार्य</h3>
              <ul>
                <li>ग्रामपंचायतेच्या सर्व दैनंदिन प्रशासकीय कामकाजाची देखरेख</li>
                <li>सरकारच्या योजना, अनुदान व फॉर्म भरणे</li>
                <li>ग्रामपंचायतेचे लेखा-जोखा, बिल पास करणे</li>
                <li>जन्म-मृत्यू, विवाह प्रमाणपत्र देणे</li>
                <li>ग्रामसभेच्या कार्यवाहीचे रेकॉर्ड ठेवणे</li>
                <li>ग्रामपंचायतेच्या सर्व कागदपत्रांची देखभाल करणे</li>
                <li>जनतेकडून येणारे अर्ज व तक्रारी हाताळणे</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Members Table (if members are added later) */}
      {members.length > 0 && (
        <section className="section">
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>अ.क्र.</th>
                  <th>नाव</th>
                  <th>वार्ड</th>
                  <th>संपर्क</th>
                </tr>
              </thead>
              <tbody>
                {members.map((m) => (
                  <tr key={m.sr}>
                    <td>{m.sr}</td>
                    <td>{m.name}</td>
                    <td>{m.ward}</td>
                    <td>{m.phone}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}

      {/* Map Section */}
      <section className="map-section">
        <h2 className="map-title">📍 ग्रामपंचायत धाकटी-डहाणू – स्थान</h2>
        <p className="map-subtitle">
          ग्रामपंचायत धाकटी-डहाणू, तालुका डहाणू, जिल्हा पालघर
        </p>
        <div className="map-container">
          <iframe
            title="Dhakati Dahanu Location"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2253.407455634562!2d72.714823!3d19.967238!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be72760a2d987fb%3A0xd9c33902c0678a22!2sDhakati%20Dahanu%2C%20Dahanu%2C%20Maharashtra%2C%20India!5e1!3m2!1sen!2sus!4v1774874624020!5m2!1sen!2sus"
            width="100%"
            height="450"
            style={{ border: 0 }}
            loading="lazy"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default Home; 